import * as yup from 'yup'
import { i18WithDefault as t } from '../shared/locales'

export const forgotPasswordSchema = yup.object({
  email: yup.string().email(t('password.email.error')).required(t('password.emailRequired.error')),
})
